'use client'

import { CheckIcon } from '@radix-ui/react-icons'
import { ReactNode } from 'react'

interface PricingCardProps {
    title: string
    savings?: ReactNode
    basePrice?: ReactNode
    price: ReactNode
    billingCycle: string
    benefits: string[]
}

export const PricingCard = ({
    title,
    savings,
    basePrice,
    price,
    billingCycle,
    benefits,
}: PricingCardProps) => {
    return (
        <div className="shadow-2xl bg-white flex flex-1 flex-col w-full gap-4 rounded-lg p-8">
            <div className="flex justify-between items-center flex-wrap">
                <h2 className="leading-[1.5] font-bold text-[28px] md:text-[32px]">{title}</h2>
                {savings && (
                    <p className="bg-neotaste rounded-full p-2 font-semibold text-[12px]">
                        {savings}
                    </p>
                )}
            </div>
            <hr />

            {basePrice && <p className="text-[20px] md:text-[22px] line-through">{basePrice}</p>}

            <p className="leading-[1.5] font-bold text-[28px] md:text-[32px]">{price}</p>

            <p className="font-normal text-black/70 text-[14px] md:text-[16px]">{billingCycle}</p>
            <ul className="flex flex-col gap-4">
                {benefits.map((benefit) => (
                    <li key={benefit}>
                        <div className="flex items-start gap-4 text-[14px] md:text-[16px]">
                            <CheckIcon className="h-5 w-full max-w-5 bg-neotaste rounded-full p-1 md:mt-1" />
                            {benefit}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}
